module.exports = __webpack_public_path__ + "static/media/golang.faa6f60c.svg";